import Image from "next/image";
import Link from "next/link";
import React from "react";

const MobileApps = () => {
    return (
        <div className=" md:pt-20 pt-10 md:px-1 px-4 pb-6">
            <div className="max-w-5xl mx-auto">
                <div className="flex mobile__apps items-center justify-center md:gap-16 gap-4">
                    <div className=" md:pr-0 pr-6 md:h-80 h-40 md:w-auto w-full">
                        <Image
                            src="/images/mobile.png"
                            alt="mobile app"
                            width={0}
                            height={0}
                            className="w-full h-full object-contain"
                            sizes="(max-width: 768px) 100vw, 33vw"
                        />
                    </div>

                    <div className="">
                        <h3 className="md:text-4xl text-base text-black md:mb-7 mb-2">
                            Download HOD App
                        </h3>
                        <div className="flex md:pt-12 pt-4">
                            <Link
                                className="md:mr-5 mr-2 h-12 md:w-32 w-16"
                                href="https://play.google.com/store/apps/details?id=com.hodapp"
                                target="_blank"
                            >
                                <Image
                                    src="/images/google_play.png"
                                    alt="Download HOD App on Android"
                                    width={0}
                                    height={0}
                                    className="w-full h-full object-contain"
                                    sizes="(max-width: 768px) 100vw, 33vw"
                                />
                            </Link>
                            <Link
                                className="h-12 md:w-32 w-16"
                                href="https://apps.apple.com/in/app/hod-house-of-diagnostics/id1639120504"
                                target="_blank"
                            >
                                <Image
                                    src="/images/apple_store.png"
                                    alt="Download HOD App on iOS"
                                    width={0}
                                    height={0}
                                    className="w-full h-full object-contain"
                                    sizes="(max-width: 768px) 100vw, 33vw"
                                />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MobileApps;
